import { render, staticRenderFns } from "./SelectBathrooms.vue?vue&type=template&id=3544906e&"
import script from "./SelectBathrooms.vue?vue&type=script&lang=js&"
export * from "./SelectBathrooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kristiankalva/Local Sites/ensign-boligprosjekter/app/public/wp-content/plugins/ensign-boligprosjekter/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3544906e')) {
      api.createRecord('3544906e', component.options)
    } else {
      api.reload('3544906e', component.options)
    }
    module.hot.accept("./SelectBathrooms.vue?vue&type=template&id=3544906e&", function () {
      api.rerender('3544906e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SelectBathrooms.vue"
export default component.exports